export default __webpack_public_path__ + "static/media/cleaning-table.c68dac25.jpg";